import React from "react";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa";

function BeltFormCard({
  belts,
  form,
  selectedGrade,
  saving,
  onChange,
  onSubmit,
  onCancel,
}) {
  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-orange-600 dark:text-orange-200">
          {selectedGrade ? "Modification" : "Nouveau passage"}
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          {selectedGrade
            ? "Modifier un passage de grade"
            : "Ajouter un passage de grade"}
        </h2>

        <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
          Sélectionne la ceinture obtenue et la date de passage.
        </p>
      </div>

      <form onSubmit={onSubmit} className="mt-5 space-y-4">
        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Ceinture
          </span>

          <select
            name="belt_id"
            value={form.belt_id}
            onChange={onChange}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-orange-300 focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10"
          >
            <option value="">Sélectionnez une ceinture</option>

            {belts.map((belt) => (
              <option key={belt.id} value={belt.id}>
                {belt.nom}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Date de passage
          </span>

          <input
            type="date"
            name="date_passage"
            value={form.date_passage}
            onChange={onChange}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-orange-300 focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10"
          />
        </label>

        <div className="grid gap-2 sm:grid-cols-2">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-orange-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-orange-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
          >
            {selectedGrade ? <FaCheck /> : <FaPlus />}
            {saving
              ? "Enregistrement..."
              : selectedGrade
                ? "Modifier"
                : "Ajouter"}
          </button>

          {selectedGrade && (
            <button
              type="button"
              onClick={onCancel}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
            >
              <FaTimes />
              Annuler
            </button>
          )}
        </div>
      </form>
    </article>
  );
}

export default BeltFormCard;